import { Controller } from "@hotwired/stimulus"

// Manages hover tooltips for calendar events
export default class extends Controller {
  connect() {
    this.initializeTooltips()
    
    // Re-initialize when view changes
    this.element.addEventListener('calendar-view:view-changed', () => {
      setTimeout(() => this.initializeTooltips(), 100)
    })
  }
  
  initializeTooltips() {
    const eventItems = document.querySelectorAll('.event-hover-tooltip')
    
    eventItems.forEach(item => {
      const tooltip = item.querySelector('.event-tooltip')
      if (!tooltip) return
      
      // Remove old listeners to avoid duplicates
      item.removeEventListener('mouseenter', this.showTooltip)
      item.removeEventListener('mouseleave', this.hideTooltip)
      
      // Add new listeners
      item.addEventListener('mouseenter', () => {
        tooltip.classList.remove('hidden')
      })
      
      item.addEventListener('mouseleave', () => {
        tooltip.classList.add('hidden')
      })
    })
  }
}

